module.exports = __webpack_public_path__ + "static/media/turnos.4b2af3d2.svg";